import { i18n } from "../../translate/i18n";

import React, { useState, useEffect, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";

import { Button, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { IconButton, InputAdornment, Switch } from "@mui/material";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import EmailIcon from "@material-ui/icons/Email";
import LockIcon from "@material-ui/icons/Lock";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

import api, { openApi } from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import defaultLoginLogo from "../../assets/login-logo-default.png";
import Turnstile from "../../components/Security/Turnstile";
import InstallKoraxCard from "../../components/InstallKoraxCard";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    width: "100vw",
    minHeight: "100vh",

    overflowX: "hidden",
    overflowY: "auto",

    background:
      "radial-gradient(circle at top left, rgba(37,99,235,0.35) 0%, rgba(2,6,23,1) 35%), linear-gradient(180deg, #020617 0%, #081028 100%)",
},
  rootWithBackground: {
    backgroundColor: "#d1d5db",
  },
  backgroundOverlay: {
    position: "absolute",
    inset: 0,
    zIndex: 0,

    background:
      "linear-gradient(180deg, rgba(2,6,23,0.4) 0%, rgba(2,6,23,0.82) 100%)",
},
  backgroundMedia: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 0,
  },
  backgroundImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center center",
    userSelect: "none",
    pointerEvents: "none",
  },
  formContainer: {
    position: "relative",
    zIndex: 2,

    width: "100%",
    maxWidth: "324px",

    background: "rgba(5, 15, 45, 0.78)",

    backdropFilter: "blur(18px)",

    border: "1px solid rgba(59,130,246,0.35)",

    borderRadius: "28px",

    boxShadow:
      "0 0 0 1px rgba(59,130,246,0.08), 0 25px 80px rgba(0,0,0,0.55), 0 0 60px rgba(37,99,235,0.18)",

    padding: "12px 24px 08px",

    margin: "16px",

    animation: "$fadeIn .45s ease",

    overflow: "hidden",

    "&:before": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "28px",
      padding: 1,
      background:
        "linear-gradient(180deg, rgba(96,165,250,0.45), rgba(59,130,246,0.08))",
      WebkitMask:
        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "xor",
      pointerEvents: "none",
    },

    [theme.breakpoints.down("sm")]: {
      maxWidth: "340px",
      padding: "32px 22px 20px",
      borderRadius: "24px",
    },
},
  "@keyframes fadeIn": {
    "0%": { opacity: 0, transform: "translateY(10px)" },
    "100%": { opacity: 1, transform: "translateY(0)" },
  },
  logoImg: {
    display: "block",
    margin: "0 auto 22px",
    maxWidth: "120px",
    height: "auto",
    filter: "drop-shadow(0 0 24px rgba(59,130,246,0.35))",
},
  heading: {
    textAlign: "center",
    marginBottom: 2,
    color: "#ffffff",
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: "-0.04em",
},
  subtitle: {
    textAlign: "center",
    color: "rgba(255,255,255,0.58)",
    marginBottom: 18,
    fontSize: 13,
    fontWeight: 400,
},
  submitBtn: {
    marginTop: "14px",

    background:
      "linear-gradient(90deg, #1D4ED8 0%, #4F46E5 100%)",

    color: "#fff",

    borderRadius: "14px",

    padding: "12px",

    fontWeight: 700,

    fontSize: "0.95rem",

    width: "100%",

    textTransform: "none",

    boxShadow:
      "0 12px 24px rgba(37,99,235,0.28)",

    "&:hover": {
      background:
        "linear-gradient(90deg, #2563EB 0%, #5B4FFF 100%)",

      transform: "translateY(-1px)",
    },
},
  registerBtn: {
    background: "transparent",

    color: "#ffffff",

    borderRadius: "14px",

    border: "1px solid rgba(255,255,255,0.14)",

    padding: "12px",

    fontWeight: 700,

    width: "100%",

    marginTop: "12px",

    textTransform: "none",

    "&:hover": {
      background: "rgba(255,255,255,0.04)",
    },
},
  forgotPasswordLink: {
    color: "#60A5FA",
    textDecoration: "none",
    fontWeight: 500,
    fontSize: "0.9rem",

    "&:hover": {
      color: "#93C5FD",
    },
},
  rememberMeContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "8px",
  },
  versionCompany: {
    marginTop: 14,
    textAlign: "center",
    fontSize: 12,
    fontWeight: 600,
    color: "#64748b",
    letterSpacing: "0.02em",
  },
  whatsappButton: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25D366",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 4px 12px #044012",
    cursor: "pointer",
    zIndex: 999,
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#1ebe5b",
      transformOrigin: "center center",transform: "scale(0.88)",
transformOrigin: "center center",
    },
  },
  whatsappIcon: {
    fontSize: 34,
    color: "#fff",
  },
}));

const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

// resolve URL vinda do backend (relativa ou absoluta) com fallback
const resolveImageUrl = (value, fallback) => {
  if (!value) return fallback;
  if (value.startsWith("http")) return value;
  if (!backendUrl) return value;
  const base = backendUrl.replace(/\/+$/, "");
  const clean = value.replace(/^\/+/, "");
  return `${base}/${clean}`;
};

const isDefaultBackendBackground = (value) => {
  if (!value) return true;
  const normalized = String(value).toLowerCase();
  return normalized.includes("/public/branding/login-background-default");
};

const Login = () => {
  const classes = useStyles();
  const { handleLogin } = useContext(AuthContext);

  const [user, setUser] = useState({
    email: "",
    password: "",
    remember: false,
  });

  const [branding, setBranding] = useState({
    loginLogo: "/logo.png",
    loginBackground: "",
    loginWhatsapp: "https://wa.me/5500000000000",
    companyName: "Korax",
  });

  const [error] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [userCreationEnabled, setUserCreationEnabled] = useState(true);
  const [turnstileToken, setTurnstileToken] = useState("");
  const [turnstileResetKey, setTurnstileResetKey] = useState(0);

  // ========= Tema e aparência da página =============
  useEffect(() => {
    try {
      localStorage.setItem("theme", "light");
    } catch (e) {}
    document.documentElement.classList.remove("dark");
    document.documentElement.setAttribute("data-theme", "light");
    document.body.classList.add("login-page");
    return () => document.body.classList.remove("login-page");
  }, []);

  // ========= Buscar settings globais ============
  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const [{ data: brandingData }, { data: publicAppName }] =
          await Promise.all([
            api.get("/global-config/public-branding"),
            openApi.get("/public-settings/appName", {
              params: { token: "wtV" },
            }),
          ]);

        setBranding({
          loginLogo: brandingData.loginLogo || "/logo.png",
          loginBackground: isDefaultBackendBackground(brandingData.loginBackground)
            ? ""
            : brandingData.loginBackground,
          loginWhatsapp: brandingData.loginWhatsapp || "https://wa.me/5500000000000",
          companyName: String(publicAppName || "").trim() || "Korax",
        });
      } catch (err) {
        console.error("Erro ao carregar branding:", err);
      }
    };

    fetchBranding();
  }, []);


  // ========== Verificar se cadastro está habilitado ==========
  useEffect(() => {
    const fetchUserCreationStatus = async () => {
      try {
        const { data } = await api.get("/settings/userCreation");
        setUserCreationEnabled(data.userCreation === "enabled");
      } catch (err) {
        setUserCreationEnabled(false);
      }
    };

    fetchUserCreationStatus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!turnstileToken) {
      toast.error(
        "Confirme que você é humano antes de continuar."
      );
      return;
    }

    const lang =
      localStorage.getItem("i18nextLng") || "pt";

    i18n.changeLanguage(lang);

    await handleLogin({
      ...user,
      turnstileToken
    });

    setTurnstileToken("");
    setTurnstileResetKey(current => current + 1);
  };

  return (
    <>
      <Helmet>
        <title>Entrar na Korax | Plataforma de IA para WhatsApp</title>
        <meta
          name="description"
          content="Acesse sua conta Korax e gerencie sua operação comercial no WhatsApp com inteligência artificial, CRM, automação, agenda e follow-up."
        />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div
        className={`${classes.root} ${branding.loginBackground ? classes.rootWithBackground : ""}`}
      >
        {!!branding.loginBackground && (
          <>
            <div className={classes.backgroundMedia}>
              <img
                src={resolveImageUrl(branding.loginBackground, "")}
                alt="Background login"
                className={classes.backgroundImg}
              />
            </div>
            <div className={classes.backgroundOverlay} />
          </>
        )}
        <form
          className={classes.formContainer}
          onSubmit={handleSubmit}
        >
          <img
            src={resolveImageUrl(branding.loginLogo, defaultLoginLogo)}
            alt="Logo"
            className={classes.logoImg}
          />

          <Typography className={classes.heading}>Entrar</Typography>
          <Typography className={classes.subtitle}>
            Acesse sua conta para continuar.
          </Typography>

          {error && <Typography color="error">{error}</Typography>}

          <TextField
  placeholder="Email"
  variant="outlined"
  fullWidth
  margin="normal"
  type="email"
  value={user.email}
  onChange={(e) => setUser({ ...user, email: e.target.value })}
  InputLabelProps={{
    style: { color: "rgba(255,255,255,0.55)" }
  }}
  InputProps={{
style: {
  background: "rgba(255,255,255,0.04)",
  borderRadius: "12px",
  color: "#ffffff",
  overflow: "hidden",
},
    startAdornment: (
      <InputAdornment position="start">
        <EmailIcon style={{ color: "rgba(255,255,255,0.75)" }} />
      </InputAdornment>
    ),
  }}
inputProps={{
  style: {
    borderRadius: "12px",
  }
}}
/>

          <TextField
            placeholder="Senha"
            variant="outlined"
            fullWidth
            margin="normal"
          InputLabelProps={{
  style: { color: "rgba(255,255,255,0.55)" }
}}

            type={showPassword ? "text" : "password"}
            value={user.password}
            onChange={(e) => setUser({ ...user, password: e.target.value })}
            InputProps={{
        style: {
        background: "rgba(255,255,255,0.04)",
        borderRadius: 12,
        color: "#ffffff",
      },
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    style={{ color: "#374151" }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <div className={classes.rememberMeContainer}>
            <Switch
              checked={user.remember}
              onChange={(e) =>
                setUser({ ...user, remember: e.target.checked })
              }
            />
            <Typography style={{ color: "rgba(255,255,255,0.72)", fontSize: 14 }}>
  Lembrar de mim
</Typography>
          </div>

          <Turnstile
            action="login"
            onToken={setTurnstileToken}
            resetKey={turnstileResetKey}
            theme="dark"
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submitBtn}
            disabled={!turnstileToken}
          >
            Entrar
          </Button>

          <InstallKoraxCard />

          {userCreationEnabled && (
            <Button
              component={RouterLink}
              to="/signup"
              variant="contained"
              className={classes.registerBtn}
            >
              Cadastre-se
            </Button>
          )}

          <div className={classes.forgotPassword}>
            <RouterLink
              to="/forgot-password"
              className={classes.forgotPasswordLink}
            >
              Esqueceu a senha?
            </RouterLink>
          </div>
        </form>

        {/* ===== BOTÃO WHATSAPP DINÂMICO ===== */}
        <div
          className={classes.whatsappButton}
          onClick={() => window.open(branding.loginWhatsapp)}
        >
          <WhatsAppIcon className={classes.whatsappIcon} />
        </div>
      </div>
    </>
  );
};

export default Login;
